import { RequestStatus } from './RequestStatus'

export default class PublishClientTemplateRequestStatusModel {
  public status: RequestStatus
  public errorDetail: string
}
